import { TabsProps, Tabs, Tab, styled } from '@mui/material'
import React from 'react'

export const ButtonTabs = styled((props: TabsProps) => <Tabs {...props} />)({
  minHeight: '36px',
  '& .MuiTabs-indicator': {
    height: '100%',
    zIndex: 1,
    borderRadius: '4px',
  },
})
export const ButtonTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.common.black,
  padding: 0,
  minHeight: '36px',
  zIndex: 2,
  transition: 'color 0.3s ease', // Smooth transition for color change
  '&.Mui-selected': {
    color: '#fff',
  },
  '&:not(.Mui-selected)': {
    color: theme.palette.common.black, // Explicitly set unselected color
  },
}))
